module.exports = __webpack_public_path__ + "703495604d10c4a34e573292958c98c3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/beach.png
// module id = 2486
// module chunks = 0